<template>
  <div>
    <h2 class="font-nutino font-bold lg:font-extrabold text-[18px] lg:text-[48px] leading-[1.4]">{{ t('b2b.wellbeing.status.title') }}</h2>
    <div class="flex flex-col lg:flex-row gap-[16px] mt-[48px]">
      <Card transparent>
        <div class=" p-[24px] w-full">
          <div class="py-[18px] bg-white flex items-center justify-center rounded-[20px] h-[275px] md:rounded-[40px] max-w-[554px]">
            <NuxtImg src="/wellbeing/charts/1.svg" />
          </div>
          <div>
            <p class="font-nutino font-medium text-[14px] lg:text-[24px] leading-[1.4] mt-3">{{ t('b2b.wellbeing.status.card.1') }}</p>
          </div>
        </div>
      </Card>
      <Card transparent>
        <div class=" p-[24px] w-full">
          <div class="py-[18px] bg-white flex items-center justify-center rounded-[20px] h-[275px] md:rounded-[40px] max-w-[554px]">
            <NuxtImg src="/wellbeing/charts/2.svg" />
          </div>
          <div>
            <p class="font-nutino font-medium text-[14px] lg:text-[24px] leading-[1.4] mt-3">{{ t('b2b.wellbeing.status.card.2') }}</p>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script setup lang="ts">
import Card from '../ui/Card.vue';

const { t } = useI18n();

</script>
